/**
 * TSOG 商品ランキング - Swiper初期化
 */

class TsogProductRanking {
  constructor() {
    this.init();
  }

  init() {
    if (typeof Swiper !== 'undefined') {
      this.initializeSliders();
    } else {
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          this.initializeSliders();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkSwiper);
        console.warn('Swiper library failed to load for ranking');
      }, 10000);
    }
  }

  initializeSliders() {
    if (!window.tsogRankingSections || window.tsogRankingSections.length === 0) {
      return;
    }

    window.tsogRankingSections.forEach((config) => {
      if (config.showSlider) {
        this.initializeSlider(config);
      }
    });

    window.tsogRankingSections = [];
  }

  initializeSlider(config) {
    const {
      sectionId,
      slidesPerView = 4,
      slidesPerViewMobile = 2
    } = config;

    const swiperElement = document.querySelector(`.tsog-ranking-swiper-${sectionId}`);

    if (!swiperElement) {
      console.warn(`Swiper element not found for section ${sectionId}`);
      return;
    }

    if (swiperElement.swiper) {
      return;
    }

    try {
      new Swiper(swiperElement, {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: 10,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.8,
        },
        mousewheel: {
          forceToAxis: true,
        },
        grabCursor: true,
        scrollbar: {
          el: swiperElement.querySelector('.tsog-ranking-scrollbar'),
          draggable: true,
          hide: false,
        },
        breakpoints: {
          640: {
            slidesPerView: Math.min(slidesPerView, 2),
            spaceBetween: 15,
          },
          990: {
            slidesPerView: Math.min(slidesPerView, 3),
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: slidesPerView,
            spaceBetween: 20,
          },
        },
      });
    } catch (error) {
      console.error('Failed to initialize Swiper for ranking:', error);
    }
  }
}

// Shopifyテーマエディターでのリロード対応
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      new TsogProductRanking();
    }, 100);
  });

  document.addEventListener('shopify:section:reorder', () => {
    setTimeout(() => {
      new TsogProductRanking();
    }, 100);
  });
}

// 初期化実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TsogProductRanking();
  });
} else {
  new TsogProductRanking();
}
